import { PageHeader } from '../../../components/layout/Header';
import { Button } from '../../../components/ui';
import { Alert, AlertDescription, AlertTitle } from '../../../components/ui/alert';
import Spinner from '../../../components/ui/Spinner';
import { useAdminFinanceStats } from '../hooks/useAdminFinanceStats';
import { FinanceKpiRow } from './FinanceKpiRow';
import { RevenueByPlanSection } from './RevenueByPlanSection';
import { AddonsSection } from './AddonsSection';
import { PastDueSection } from './PastDueSection';
import { InvoicesSection } from './InvoicesSection';

export function AdminFinancePage() {
  const {
    data: stats,
    isLoading: statsLoading,
    error: statsError,
    refetch: refetchStats,
  } = useAdminFinanceStats();

  return (
    <div className="flex flex-col bg-background">
      <PageHeader
        title="Financeiro"
        subtitle="Receita recorrente, assinaturas e inadimplência"
        titleClassName="text-xl font-semibold tracking-tight text-default"
        subtitleClassName="text-[13px] text-muted"
        className="mb-[18px]"
        hideBackButton
      />

      {statsLoading && (
        <div className="flex items-center justify-center py-24">
          <Spinner color="primary" size="lg" />
        </div>
      )}

      {!statsLoading && statsError && (
        <Alert variant="destructive" className="mb-s5">
          <AlertTitle>Erro ao carregar indicadores</AlertTitle>
          <AlertDescription className="flex flex-col gap-s3">
            <p>{statsError}</p>
            <Button variant="outline" size="sm" onClick={() => void refetchStats()}>
              Tentar novamente
            </Button>
          </AlertDescription>
        </Alert>
      )}

      {!statsLoading && !statsError && stats && (
        <>
          <FinanceKpiRow kpis={stats.kpis} />
          <RevenueByPlanSection rows={stats.revenueByPlan} />
          <AddonsSection addons={stats.addons} />
          <PastDueSection items={stats.pastDue} />
        </>
      )}

      <InvoicesSection />
    </div>
  );
}
